// extracted by mini-css-extract-plugin
export default {"footer":"Auial","moreItemsText":"V-hHh","mobileFooter":"AKdUc"};